export default "__VITE_ASSET__4b859fa0__"